import AlertSection from '@/components/common/alert/AlertSection';
import ErrorMessage from '@/components/common/error-message/ErrorMessage';
import GoBack from '@/components/common/go-back/GoBack';
import NoData from '@/components/common/no-data/NoData';
import ServiceNotificationForm from '@/components/forms/form-service-notification/ServiceNotificationForm';
import ServiceForm from '@/components/forms/form-service/ServiceForm';
import ServiceSchedule from '@/components/forms/form-service/ServiceSchedule';
import { Skeleton } from '@/components/ui/skeleton';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import useEditService from '@/hooks/pages/useEditService';
import { useTranslation } from 'react-i18next';

const EditService = () => {
  const { t } = useTranslation();
  const {
    isLoading,
    isError,
    isPending,
    service,
    serviceId,
    sport,
    defaultValues,
    defaultSchedule,
    onSubmit,
    isScheduleConflict
  } = useEditService();

  if (isLoading) {
    return (
      <>
        <GoBack />
        <Skeleton className="w-full h-[50vh]" />
      </>
    );
  }

  if (!service || !sport) {
    return (
      <>
        <GoBack />
        <NoData />
      </>
    );
  }

  if (isError) {
    return (
      <>
        <GoBack />
        <ErrorMessage />
      </>
    );
  }

  return (
    <div className="mb-4">
      <GoBack />
      <div className="p-5 space-y-6 rounded-md bg-accent">
        <p className="font-bold text-md text-primary">
          {t('form.updateService')} - {service.name}
        </p>
        <Tabs defaultValue="serviceForm">
          <TabsList>
            <TabsTrigger value="serviceForm">{t('common.details')}</TabsTrigger>
            <TabsTrigger value="schedule">{t('common.schedules')}</TabsTrigger>
            <TabsTrigger value="notification">{t('common.notification')}</TabsTrigger>
          </TabsList>
          {isScheduleConflict && (
            <div className="mt-4">
              <AlertSection
                variant="warning"
                text={t('services.scheduleConflict')}
              />
            </div>
          )}
          <div className="mt-6">
            <TabsContent value="serviceForm">
              <ServiceForm
                defaultValues={defaultValues}
                onSubmit={onSubmit}
                isPending={isPending}
                sport={sport}
              />
            </TabsContent>
            {serviceId && (
              <TabsContent value="schedule">
                <ServiceSchedule
                  serviceId={serviceId}
                  defaultSchedule={defaultSchedule}
                />
              </TabsContent>
            )}
            {serviceId && (
              <TabsContent value="notification">
                <ServiceNotificationForm
                  service={service}
                />
              </TabsContent>
            )}
          </div>
        </Tabs>
      </div>
    </div>
  );
};

export default EditService;
